import script from "./FixedFeeEditPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FixedFeeEditPanel.vue?vue&type=script&setup=true&lang=js"

import "./FixedFeeEditPanel.vue?vue&type=style&index=0&id=488f1ed1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-488f1ed1"]])

export default __exports__